/// <amd-module name="TFS/GlobalBanner/Components/GlobalMessages" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";
import { GlobalDialogComponent } from "./GlobalDialog";
import { GlobalBannerComponent } from "./GlobalMessageBanner";
import { GlobalToastComponent } from "./GlobalToast";

class GlobalMessagesComponent extends VssComponent {
    public static componentType = "globalMessages";

    public render(): JSX.Element {
        return (
            <React.Fragment>
                <GlobalBannerComponent />
                <GlobalDialogComponent />
                <GlobalToastComponent />
            </React.Fragment>
        );
    }
}

// Register the global messages component with the layout manager
VssComponent.register(GlobalMessagesComponent.componentType, GlobalMessagesComponent);
